import React from 'react';
import PropTypes from 'prop-types';
import MaterialCheckbox from 'material-ui/Checkbox/Checkbox';

const Checkbox = (props) => {
    const {
        checked,
        checkedIcon,
        defaultChecked,
        disabled,
        label,
        onCheck,
        style,
        uncheckedIcon,
    } = props;

    return (
        <MaterialCheckbox
            checked={ checked }
            checkedIcon={ checkedIcon }
            defaultChecked={ defaultChecked }
            disabled={ disabled }
            label={ label }
            onCheck={ onCheck }
            style={ style }
            uncheckedIcon={ uncheckedIcon }
        />
    );
};

Checkbox.propTypes = {
    checked: PropTypes.bool,
    checkedIcon: PropTypes.element,
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    onCheck: PropTypes.func,
    style: PropTypes.object,
    uncheckedIcon: PropTypes.element,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/ui/checkbox/Checkbox.js